import LupaLight from "../images/LuqueLupaMuniLight.svg";
import LupaDark from "../images/LuqueLupaMuni.svg";
import VistaLista from "../images/LuqueVistaLista.svg";
import VistaTablaLight from "../images/LuqueVistaTablaLight.svg";
import VistaTablaDark from "../images/LuqueVistaTablaDark.svg";
// import VistaMiniCards from "../images/LuqueVistaCardsPeques.svg";
import Logo from "../images/Gov360.svg";
import NotificacionesLight from "../images/LuqueNotificacionesMuniLight.svg";
import NotificacionesDark from "../images/LuqueNotificacionesMuniDark.svg";
import CerrarSesionLight from "../images/LuqueCerrarSesion.svg";
import CerrarSesionDark from "../images/LuqueCerrarSesionDark.svg";
import TemaDark from "../images/themeDark.svg";
import TemaLight from "../images/themeLight.svg";

// import Logo from "@/assets/images/LuqueOfidiLogo.svg";

export const toolbarIcons = {
  lupaDark: LupaDark,
  lupaLight: LupaLight,
  vistaLista: VistaLista,
  vistaTablaLight: VistaTablaLight,
  vistaTablaDark: VistaTablaDark,
  // vistaMiniCards: VistaMiniCards,
  logo: Logo,
  notificacionesLight: NotificacionesLight,
  notificacionesDark: NotificacionesDark,
  cerrarSesionLight: CerrarSesionLight,
  cerrarSesionDark: CerrarSesionDark,
  themeDark: TemaDark,
  themeLight: TemaLight,
};
